module.exports = __webpack_public_path__ + "static/img/ninja-can-00.3450d0e5.png";